'use client';

import { Box, Grid2, Typography } from '@/primitives';
import useNewsFeed from '@/hooks/studbook/news/useNewsFeed';
import NewsCard from './NewsCard';
import { black } from '@/lib/colours';
import NewsCardSkeleton from './NewsCardSkeleton';
import { PAGE_PADDING_MOBILE_PUBLIC } from '@/configs/layout';

export default function NewsSection() {
  const { data, isLoading } = useNewsFeed();

  return (
    <Box
      sx={{
        m: 'auto',
        mt: { xs: '20px', md: 0 },
        px: `${PAGE_PADDING_MOBILE_PUBLIC}px`,
        py: { xs: `${PAGE_PADDING_MOBILE_PUBLIC}px`, md: '64px' },
        maxWidth: '1184px',
      }}
    >
      <Typography
        sx={{
          mb: { md: '16px' },
          p: '16px',
          color: black[900],
        }}
        variant="headlinesmall"
      >
        ABRI Latest News
      </Typography>
      <Grid2
        container
        columnSpacing={{ xs: '20px', md: '24px' }}
        rowSpacing={{ xs: '32px', md: 0 }}
      >
        {isLoading ? (
          <>
            <Grid2 xs={12} sm={6} md={4}>
              <NewsCardSkeleton />
            </Grid2>
            <Grid2 xs={12} sm={6} md={4}>
              <NewsCardSkeleton />
            </Grid2>
            <Grid2
              xs={12}
              md={4}
              sx={{
                display: { xs: 'none', sm: 'flex' },
                flexDirection: 'column',
                gap: '24px',
                mb: { sm: '16px', md: 'unset' },
              }}
            >
              <NewsCardSkeleton isBrief />
              <NewsCardSkeleton isBrief />
              <NewsCardSkeleton isBrief />
            </Grid2>
          </>
        ) : (
          <>
            {data?.[0] && (
              <Grid2 xs={12} sm={6} md={4}>
                <NewsCard
                  date={data[0].isoDate ? new Date(data[0].isoDate) : undefined}
                  imgUrl={data[0].mediaContent.url ?? ''}
                  referenceLink={data[0].link ?? ''}
                  snippet={data[0].contentSnippet ?? ''}
                  title={data[0].title ?? ''}
                />
              </Grid2>
            )}
            {data?.[1] && (
              <Grid2 xs={12} sm={6} md={4}>
                <NewsCard
                  date={data[1].isoDate ? new Date(data[1].isoDate) : undefined}
                  imgUrl={data[1].mediaContent.url ?? ''}
                  referenceLink={data[1].link ?? ''}
                  snippet={data[1].contentSnippet ?? ''}
                  title={data[1].title ?? ''}
                />
              </Grid2>
            )}
            {data?.[2] && (
              <Grid2
                xs={12}
                md={4}
                sx={{
                  display: { xs: 'none', sm: 'flex' },
                  flexDirection: 'column',
                  gap: '24px',
                  mb: { sm: '16px', md: 'unset' },
                }}
              >
                <NewsCard
                  date={data[2].isoDate ? new Date(data[2].isoDate) : undefined}
                  imgUrl={data[2].mediaContent.url ?? ''}
                  isBrief
                  referenceLink={data[2].link ?? ''}
                  snippet={data[2].contentSnippet ?? ''}
                  title={data[2].title ?? ''}
                />
                {data?.[3] && (
                  <NewsCard
                    date={
                      data[3].isoDate ? new Date(data[3].isoDate) : undefined
                    }
                    imgUrl={data[3].mediaContent.url ?? ''}
                    isBrief
                    referenceLink={data[3].link ?? ''}
                    snippet={data[3].contentSnippet ?? ''}
                    title={data[3].title ?? ''}
                  />
                )}
                {data?.[4] && (
                  <NewsCard
                    date={
                      data[4].isoDate ? new Date(data[4].isoDate) : undefined
                    }
                    imgUrl={data[4].mediaContent.url ?? ''}
                    isBrief
                    referenceLink={data[4].link ?? ''}
                    snippet={data[4].contentSnippet ?? ''}
                    title={data[4].title ?? ''}
                  />
                )}
              </Grid2>
            )}
          </>
        )}
      </Grid2>
    </Box>
  );
}
